<div>
    <div class="modal-header d-flex justify-content-center"
        [ngClass]="modalType == 'error' ? 'error' : modalType == 'warning' ? 'warning' : 'success'">
        <h4 class="modal-title">{{'PENDING_USER_TITLE_TEXT' | translate}}</h4>
    </div>
    <div class="modal-body text-center">
        {{'PENDING_USER_NOTE_TEXT' | translate}}
        <div class="form-group">
          <textarea class="form-control" rows="3" #pendingJustification
              [attr.maxLength]="maxReasonLength" (input)="currentLength = pendingJustification.value.length"></textarea>
          <div class="text-end small mt-1"
              [ngClass]="{'text-danger': currentLength > maxReasonLength}">
              {{currentLength}} / {{maxReasonLength}}
          </div>
          <div class="error-msg text-align" *ngIf="displayErrorMsgBlock && currentLength === 0">
                  {{'PENDING_NOTE_EMPTY_ERROR' | translate}}
          </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary btn-block primary-btn" (click)="confirmUserPendingAction()">{{'SUBMIT_TEXT' | translate}}</button>
        <button class="btn white-bg sec-button" (click)="cancelUserPendingAction()">{{'CANCEL' | translate}}</button>
    </div>
</div>